<script>

import { convert } from './ui.js';
import { clone, res } from './stores.js';
import { get } from 'svelte/store';

export let p;
export let hoveredRow;
export let showRow;
export let games;
export let captain;

let totalActions = 0;
let totalRelevantGames = 0;

// Stats view: one consolidated p across all games for this captain
$: if(games && captain) p = consolidateGames();
// Rebuild whenever p changes. The game log reuses this component inside an {#each}, so
// p gets swapped for another player's; building once on create left the old player's
// chart up (wrong icons) with none of the new player's stats matching (empty cells).
$: actions = (p && p.stats && p.stats.botActions) || {};
$: if(p) loadChart(p, actions);


function consolidateGames(){
    // Consolidate into single p
    let p = {
        captain,
        stats: {
            botActions: {}
        }
    }
    totalActions = 0;
    totalRelevantGames = 0;
    for(let g of games){
        for(let pl of g.players){
            if(!pl.bot) continue;
            if(pl.captain != captain) continue;
            if(!pl.stats || !pl.stats.botActions) continue;
            totalRelevantGames++;
            for(let k of Object.keys(pl.stats.botActions)){
                let lc = k.toLowerCase();
                if(!p.stats.botActions[k] && !p.stats.botActions[lc]) p.stats.botActions[lc] = {};
                for(let j of Object.keys(pl.stats.botActions[k])){
                    //let lc = j.toLowerCase();
                    if(!p.stats.botActions[lc][j]) p.stats.botActions[lc][j] = 0;
                    p.stats.botActions[lc][j] += pl.stats.botActions[k][j];
                }
            }
        }
    }
    return p;
}

let effectTypes = {
    'basic': 'basic effect',
    'noDO': 'non-Duty Officer effect',
    'DO': 'Duty Officer effect',
    'collective<20': '[[collective]] < 20 effect',
    'collective>=20': '[[collective]] >= 20 effect',
    
}

function percent(icon, type){
    let row = actions[icon] || {};
    let number = row[effectTypes[type]] || 0;
    if(number == 0) return '';
    let n = (number / totalActions * 100).toFixed(0);
    return n;
}

function heatMap(icon, type){
    let n = percent(icon, type);
    if(n === '') return ''; // no actions: leave the cell black
    return `background-color: hsla(0, ${n * 4}%, 50%, 0.7); color: white;`
}


let charts = [];

function loadChart(p, actions){
    let built = [];
    let total = 0;
    let bC = get(res).botCharts[p.captain];
    if(bC){
        if(bC.chart){
            built = [clone(bC.chart)];
        }else{
            // subcharts
            for(let k of Object.keys(bC).filter(k => k != 'chartName')){
                let c = clone(bC[k]);
                c.chartName = k;
                built.push(c);
            }
        }
        
    }
    for(let chart of built){
        for(let k of Object.keys(actions)){
            let key = k;
            if(k.includes('!!')){
                let [c, i] = k.split('!!');
                if(chart.chartName && c != chart.chartName) continue; // Only count those that match
                key = i;
            }
            // Multi-icon rows are recorded as 'pilot,ops' (after any 'chart!!' prefix)
            let icons = key.split(',');
            if(!icons.every(i => chart.some(row => { let rk = statKey(row); return Array.isArray(rk) && rk.some(ic => ic.toLowerCase() == i.toLowerCase()) || !Array.isArray(rk) && rk.toLowerCase() == i.toLowerCase(); }))){
                // Not in chart
                if(icons.length == 1) icons = icons[0];
                //if(icons != 'surprise') throw 'fail'
                chart.push({
                    icon: icons,
                    basic: true,
                    DO: true,
                    'nonDO': true,
                    added: icons != 'surprise'
                })
            }
        }
    }
    // Total across every key, once (not once per subchart)
    for(let k of Object.keys(actions)){
        for(let j of Object.keys(actions[k])){
            total += actions[k][j];
        }
    }
    totalActions = total;
    charts = built;
}

// Stats key for a chart row: sync rows are recorded per sync level, e.g. 'sync 2'
function statKey(row){
    return row.syncLevel ? `${row.icon} ${row.syncLevel}` : row.icon;
}

function getChartKeys(p){
    if(p.captain == 'Borg Queen'){
        return ['basic', 'collective<20', 'collective>=20']
    }else{
        return ['basic', 'noDO', 'DO']
    }
}

</script>
    {#if games}
        Info collated from {totalRelevantGames} games. 
    {/if}
        {totalActions} total actions.
        <div class="charts" on:click={e => {console.log('bot stuff', charts, p, games)}}>
            {#each charts as c}
                {#if c.chartName}{c.chartName} chart:{/if}
                <table>
                    <tr><th>Icon</th><th>Basic effect</th>
                        {#if p.captain == 'Borg Queen'}
                            <th>[[collective]] &lt; 20</th><th>[[collective]] &gt;= 20</th>
                        {:else}
                            <th>non-DO effect</th><th>DO effect</th>
                        {/if}
                    </tr>
                    {#each c as row}
                        <tr style={hoveredRow == row ? 'hover' : ''} >
                            <td style="cursor: pointer;" on:click={e => { showRow = row}}>
                                {#if Array.isArray(row.icon)}
                                    {@html convert(row.icon.map(i => `[[${i}]]`).join('/'), true)}
                                {:else}
                                    {@html convert(`[[${row.icon}]]`, true)}
                                {/if}
                                {#if row.syncLevel}{row.syncLevel}{/if}
                                {#if row.added}(not in current live chart){/if}
                            </td>
                            {#each getChartKeys(p) as type}
                                <td>
                                    {#if row[type]}
                                        <div style={heatMap(c.chartName ? c.chartName+'!!'+statKey(row) : statKey(row), type)}>
                                            {#if c.chartName}
                                                {#if actions[c.chartName+'!!'+statKey(row)]}
                                                    {actions[c.chartName+'!!'+statKey(row)][effectTypes[type]] || 0} times{#if percent(c.chartName+'!!'+statKey(row), type) !== ''} ({percent(c.chartName+'!!'+statKey(row), type)}%){/if}
                                                {/if}
                                            {:else}
                                                {#if actions[statKey(row)]}
                                                    {actions[statKey(row)][effectTypes[type]] || 0} times{#if percent(statKey(row), type) !== ''} ({percent(statKey(row), type)}%){/if}
                                                {/if}
                                            {/if}
                                        </div>
                                    {/if}
                                </td>
                            {/each}
                        </tr>
                    {/each}
                </table>
            {/each}
        </div>

<style>
    div {
        font-size: 2vmin;
    }
    table, td, th {
        font-size: 2vmin;
        border-collapse: collapse;
        border: 2px solid white;
        background-color: black;
        color: white;
        text-shadow: none; /* To remove civ-specific effects */
    }
    td {
        text-align: center;
    }

    .hover {
        background-color: white;
        /* glow of some kind? */
    }

    .charts {
        display: flex;
        align-items: flex-start;
        justify-content: space-evenly;
        align-content: center;
    }

    .modal {
		position: absolute;
		z-index: 1;
		left: 50%;
		top: 50%;
		padding: 3vmin;
		padding-bottom: 1vmin;
		transform: translate(-50%, -50%);
		max-height: 90vh;
		max-width: 90vw;
		min-width: 60vw;
		overflow: auto;
		background-color: grey;
		color: black;
		box-shadow: 0 0 5px 5px black; color: white;
	}
</style>
